﻿﻿import { Pipe, PipeTransform } from '@angular/core';
/*
 * Raise the value exponentially
 * Takes an exponent argument that defaults to 1.
 * Usage:
 *   value | exponentialStrength:exponent
 * Example:
 *   {{ 2 | exponentialStrength:10 }}
 *   formats to: 1024
*/
@Pipe({name: 'idNotIn'})
export class IdNotInPipe implements PipeTransform {
  transform(list:any[], id:any): any[] {
    return list.filter(p=>p.id != id);
  }
}
